<template>
  <div class="check">
    <div class="check_title">
      {{ $t("hzmbChange.title.already_data") }}
    </div>
    <div class="check_form_content">
      <CheckFormBox :title="$t('hzmbChange.title.formData')">
        <el-row :gutter="48" type="flex">
          <el-col :xs="24" :sm="12">
            <div class="form_label">
              {{ $t("hzmbChange.label.changeType") }}：
            </div>
            <div class="form_value">
              {{ form.changeType | getChangeTypeText }}
            </div>
          </el-col>
          <el-col v-if="!isGHCompany" :xs="24" :sm="12">
            <div class="form_label">{{ $t("hzmbChange.label.renew") }}：</div>
            <div class="form_value">
              {{
                form.renew
                  ? $t("hzmbChange.label.yes")
                  : $t("hzmbChange.label.no")
              }}
            </div>
          </el-col>
        </el-row>
      </CheckFormBox>
      <Quota
        v-if="form.quota"
        :data="form.quota"
        :caseNo="form.caseNo"
        :isGHCompany="isGHCompany"
      ></Quota>
      <Vehicle
        v-if="hasChangeVehicle || form.changeType === 'CHANGE_DRIVER'"
        :data="form.vehicle"
        :form="form"
      ></Vehicle>
      <Drivers
        v-if="form.drivers && form.drivers.length > 0 && hasChangeDriver"
        :data="form.drivers"
        :form="form"
        :isE02F02="isE02F02"
        :isGHCompany="isGHCompany"
      ></Drivers>
      <div class="check_title">
        {{ $t("hzmbChange.message.already_upload_file") }}
      </div>
      <div class="check_file_list">
        <div
          v-for="(item, index) in documents"
          :key="item.id"
          class="check_file_list_content"
        >
          <div v-if="item.file">
            <span
              >{{ index + 1 }}.{{
                item.documentType &&
                item.documentType[`name${$t("message.lan")}`]
              }}：</span
            >
            <span class="check_file_name"
              >&nbsp;{{ item.file && item.file.filename }}</span
            >
          </div>
        </div>
      </div>
      <!-- 是否同意 -->
      <div class="check_agree">
        <el-checkbox v-model="agreeCheck">{{
          $t("hzmbChange.message.hzmbFirstAgree")
        }}</el-checkbox>
      </div>
      <div class="check_agree" style="margin-top: 20px">
        <el-checkbox v-model="agreeCheck2">
          {{ $t("hzmbChange.message.agree_statement") }}
          (<a
            :href="`${localPath}/files/${
              $i18n.locale === 'PT'
                ? 'hzmb_change_statement_pt'
                : 'hzmb_change_statement'
            }.pdf`"
            target="_blank"
            class="agree-link"
            >{{ $t("hzmbChange.action.statement_detail") }}</a
          >)
        </el-checkbox>
      </div>
    </div>
    <div class="next_btn">
      <GradientBtn white @click="back">{{ $t("message.back") }}</GradientBtn>
      <GradientBtn @click="submit" :loading="loading">{{
        $t("hzmbChange.action.submit")
      }}</GradientBtn>
    </div>
  </div>
</template>

<script>
import Quota from "./components/Check/Quota";
import Vehicle from "./components/Check/Vehicle";
import Drivers from "./components/Check/Drivers";
import GradientBtn from "@/components/GradientBtn.vue";
import HzmbVehDriApplicationChangeAPI from "@/api/HzmbVehDriApplicationChangeAPI";
import CheckFormBox from "../../Check/components/CheckFormBox.vue";
import { getChangeTypeText } from "./options";
export default {
  components: { Quota, Vehicle, Drivers, GradientBtn, CheckFormBox },
  data() {
    return {
      loading: false,
      id: this.$route.params.applicationId,
      form: {},
      documents: [],
      agreeCheck: null,
      agreeCheck2: null,
      localPath: process.env.VUE_APP_BASE_LOCAL_PATH,
    };
  },
  filters: { getChangeTypeText },
  computed: {
    serviceType() {
      return this.$route.params.serviceType;
    },
    applicantType() {
      switch (this.serviceType) {
        case "HZMB_CHANGE_PERSON":
          return "PERSON";
        case "HZMB_CHANGE_COMP":
        case "HZMB_GH_CHANGE_COMP":
          return "PERSON";
        default:
          return "";
      }
    },
    hasChangeVehicle() {
      const { changeType } = this.form;
      return ["CHANGE_VEHICLE", "CHANGE_VEHICLE_DRIVER"].includes(changeType);
    },
    hasChangeDriver() {
      const { changeType } = this.form;
      return ["CHANGE_DRIVER", "CHANGE_VEHICLE_DRIVER"].includes(changeType);
    },
    isGHCompany() {
      return this.serviceType === "HZMB_GH_CHANGE_COMP";
    },
    isE02F02() {
      const { hzmbSubtype } = this.form;
      return this.isGHCompany && ["E02", "F02"].includes(hzmbSubtype);
    },
    isChangeDriver() {
      return this.form.changeType === "CHANGE_DRIVER";
    },
  },
  methods: {
    submit() {
      // 首次申請需要勾選同意checkbox
      if (!this.agreeCheck || !this.agreeCheck2) {
        this.$message({
          type: "error",
          message: this.$t("hzmbChange.message.terms_agree"),
        });
        return;
      }
      this.$confirm(
        this.$t("message.confirm_submit_content"),
        this.$t("message.tips"),
        {
          confirmButtonText: this.$t("message.confirm"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.doSubmit();
        })
        .catch(() => {
          return;
        });
    },
    async doSubmit() {
      try {
        this.loading = true;
        await HzmbVehDriApplicationChangeAPI.submit(this.id);

        if (this.serviceType === "HZMB_GH_CHANGE_COMP") {
          this.$router.push(`/hzmb-change-vd/success/${this.id}`);
        } else {
          this.$router.push(
            `/hzmb-change-vd/${this.serviceType}/payment/${this.id}`
          );
        }
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
    back() {
      this.$router.push({
        name: "hzmbChangeVDUpload",
        params: {
          applicationId: this.$route.params.applicationId,
        },
      });
    },
    // 獲取暫存數據
    async get() {
      try {
        this.loading = true;
        const { hzmbVehDriChangeApplication, documents } =
          await HzmbVehDriApplicationChangeAPI.findById(this.id);
        this.form = this.formatForm(hzmbVehDriChangeApplication);
        this.documents = documents;
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
    formatForm(application) {
      let resetForm = {
        quota: { macauAddress: {} },
        vehicle: {},
        drivers: [{}],
      };
      let quota = application.quota;
      if (quota) {
        // 電話去掉區號
        if (quota.mainlandPhone) {
          quota.mainlandPhone = quota.mainlandPhone.replace(/86-/g, "");
        }
        if (quota.hkPhone) {
          quota.hkPhone = quota.hkPhone.replace(/852-/g, "");
        }
        // 地址初始化
        if (!quota.macauAddress) quota.macauAddress = {};
      }
      // 電話去掉區號
      let drivers = application.drivers;
      if (drivers && drivers.length > 0) {
        application.drivers = drivers.map((ele) => {
          if (ele.mainlandPhone) {
            ele.mainlandPhone = ele.mainlandPhone.replace(/86-/g, "");
          }
          return ele;
        });
      } else {
        application.drivers = [{}];
      }
      // 內地車牌去除“粤”
      let vehicle = application.vehicle;
      if (vehicle) {
        vehicle.regAndIdNo = vehicle.registrationNo;
        if (vehicle.plateNoCn) {
          vehicle.plateNoCn = vehicle.plateNoCn.replace(/(粤|粵)/g, "");
        }
      }
      resetForm = application;

      return resetForm;
    },
  },
  created() {
    this.get();
  },
};
</script>

<style lang="scss" scoped>
.check {
  background: #fff;
  overflow: hidden;
  padding: 14px;
  max-width: 1200px;
  overflow: hidden;
  margin: auto;
}

.check_title {
  max-width: 867px;
  margin: auto;
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  color: #262626;
  border-bottom: 3px solid #38959d;
  padding: 16px 0;
}

.check_file_list {
  max-width: calc(867px - 48px);
  width: calc(100% - 48px);
  margin: 24px auto;
  border-radius: 8px;
  border: 1px solid rgba(151, 151, 151, 1);
  padding: 24px;
}

.check_file_list_content {
  max-width: 760px;
  margin: auto;
  margin-bottom: 24px;
  font-size: 16px;
  line-height: 22px;
}

.check_file_name {
  color: #5ba7ad;
}

/deep/.check_agree {
  max-width: 867px;
  margin: auto;

  .el-checkbox {
    white-space: normal;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .el-checkbox__label {
    font-size: 16px;
  }
  .agree-link {
    color: #5ba7ad;
  }
}
</style>
